<template>  
  <div v-if="SelectedMarkup != null" style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 150px; pointer-events: none" :style="{'top' : SelectedMarkup.Coords.Y + 60 + 'px', 'left' : SelectedMarkup.Coords.X + 'px', 'position' : 'absolute'}">
    <div style="border-bottom: 2px solid #c9c9c9; width: 100%; font-weight: bold; padding-left: 3px; padding-right: 3px">
      {{SelectedMarkup.Hint}}
    </div>
  </div>
  <div ref="ElementoGrafico">
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico"></canvas>
  </div>      
</template>

<script>
import { TZGraphLabelType, TZGraphHistogram, TZGraphNotchType } from '@/utils/ZGraph.js'
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import { COLORI_ALLARME_CRONOLOGIA_ACC, SystemInformation } from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZMathFunct } from '@/utils/ZMathFunct.js'

export default 
{
  components: { },
  mixins: [ MixInsGestioneTraduzioni ],
  data() 
  {
    return {
              ObjGrafico     : null,
              SelectedMarkup : null,
              Grafici        : {},
              ColoriAllarme  : COLORI_ALLARME_CRONOLOGIA_ACC,
              DatiUrl        : {},
              LinguaUtente   : SystemInformation.UserInformation.Lingua
           }

  },
  props: [ "WidthGrafico", "HeightGrafico", "Dati", "Repaint", "RepaintDeep" ],

  methods:
  {
    GetMaxAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result < this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result > this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinDelta(Element)
    {
      return Math.min(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    GetMaxDelta(Element)
    {
      return Math.max(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    Adatta()
    {
      this.ObjGrafico.AxisX.Min = this.Dati.AsseX.Min
      this.ObjGrafico.AxisX.Max = this.Dati.AsseX.Max
      this.ObjGrafico.AxisX.NotchDim = this.Dati.AsseX.Udm
    },

    // GetMousePosOncanvas(event)
    // {
    //   this.ObjGrafico.AnnullaLastMarkup()
    //   this.SelectedMarkup = null
    //   this.SelectedMarkup = this.ObjGrafico.HighlightMarkup(event.offsetX, event.offsetY)
    // },

    InserisciDati()
    {
      this.ObjGrafico.ClearAllGroupPoint()

      let SpessoreGrafico = (this.Dati.AsseX.Max - this.Dati.AsseX.Min) / 100
      let Grafico = this.ObjGrafico.AddGroupPoint(0, 'blue', SpessoreGrafico, true)
      
      this.ObjGrafico.PointWidth = SpessoreGrafico

      let Punti = []

      this.Dati.Generale.Punti.forEach((element) =>
      {
        let X = element
        // ho messo 1 ms di tolleranza, perché i dati su ew sembravano avere della tolleranza
        let index = Punti.findIndex((Punto) => {return (Punto.X >= X - 1 && Punto.X <= X + 1)})
        if (index != -1)
          Punti[index].Y++
        else
          Punti.push({X: X, Y: 1})
      })

      Punti.forEach((element) =>
      {
        let Hint = {}
        Grafico.AddPoint(element.X, element.Y, Hint, [], null, 'blue')
      })
    },

    Disegna()
    {
      this.Adatta()
      this.InserisciDati()
      setTimeout(() => { this.ObjGrafico.Paint()}, 1)
    },
  },

  computed:
  {
    PropsGraficoPerModifica :
    {
      get()
      {
        return this.PropsGrafico
      }
    }
  },

  watch:
  {
    Repaint:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.ObjGrafico.AxisX.Max      = this.Dati.AsseX.Max
          this.ObjGrafico.AxisX.Min      = this.Dati.AsseX.Min
          this.ObjGrafico.AxisX.NotchDim = this.Dati.AsseX.Udm
          this.ObjGrafico.AxisY.Min      = 0
          this.ObjGrafico.AxisY.Max      = this.Dati.AsseY.Max
          this.ObjGrafico.AxisY.NotchDim = this.Dati.AsseY.Udm
          this.ObjGrafico.AxisY.Inverted = false
          setTimeout(() => { this.ObjGrafico.Paint()}, 1)
        }
      }
    },

    RepaintDeep:
    {
      handler()
      {
        this.Disegna()
      }
    },
  },

  mounted()
  {
    this.ObjGrafico = new TZGraphHistogram(this.$refs.Canvas)
    this.ObjGrafico.AxisX.NotchFontSize = 13
    this.ObjGrafico.AxisY.FontSize = 15
    this.ObjGrafico.AxisX.FontSize = 15
    this.ObjGrafico.AxisY.CenterLabel = this.GetTraduzioneLabel('VUEComponenteGraficoIncidenza','TKN_GRAF_INC',this.LinguaUtente)
    this.ObjGrafico.__Margins.MinLeft   += 30
    this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblInteger
    this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblInteger
    if(this.ObjGrafico.AxisX.NotchDim != undefined)
            this.ObjGrafico.AxisX.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisX.NotchDim))
    if(this.ObjGrafico.AxisY.NotchDim != undefined)
            this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
    this.ObjGrafico.AxisX.Min           = this.Dati.AsseX.Min    
    this.ObjGrafico.AxisX.Max           = this.Dati.AsseX.Max
    this.ObjGrafico.AxisX.NotchDim      = this.Dati.AsseX.Udm

    this.ObjGrafico.AxisY.Min           = this.Dati.AsseY.Min
    this.ObjGrafico.AxisY.Max           = this.Dati.AsseY.Max
    this.ObjGrafico.AxisY.NotchDim      = this.Dati.AsseY.Udm
    this.ObjGrafico.AxisX.NotchPenWidth = 1
    this.ObjGrafico.AxisY.NotchPenWidth = 1
    this.ObjGrafico.AxisX.NotchColor    = 'grey'
    this.ObjGrafico.AxisY.NotchColor    = 'grey'

    this.InserisciDati()
    // this.$refs.Canvas.addEventListener('mousemove', this.GetMousePosOncanvas)
    setTimeout(() => { this.ObjGrafico.Paint()}, 1)
  },

  beforeMount()
  {
    let Parametri = TZGenericFunct.GetURLParameters() 
    this.DatiUrl.DataStart = parseInt(Parametri.Data)
  },
}
</script>